import { components } from "react-select";

export const CustomSingleValue = (props: any) => {
  const { data } = props;

  return (
    <components.SingleValue {...props}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={data.image}
          alt={data.label}
          style={{
            width: "35px",
            height: "25px",
            objectFit: "cover",
            borderRadius: "6px",
          }}
        />
        <span>{data.label}</span>
      </div>
    </components.SingleValue>
  );
};
